import $ from 'jquery';
import 'jquery';
import './bootstrap';
import smoothscroll from 'smoothscroll-polyfill';
import retina from 'retinajs';


import './map-settings';
import './infoModal';
import umeReadyAccordions from './accordion';
import umeMoreFrontend from './ume-more-frontend';
import umeMenuInit from './menu';
import umeSlidersInit from  './events-slider';
import scrollDownOnClick from './scrollDown';
import initSliders from "./slider";
import initUpcomingEventsSliders from "./upcoming-events";
import studiesSelect from "./studiesSelect";
import checkIfAnchorIsInViewport from "./checkIfAnchorIsInViewport";
import setScrollPadding from './setScrollPadding';
import consentmanager from './consentmanager';
import consentManagerHandleBackground from "./consentManagerHandleBackground";
import linktree from "./linktree";

$(document).ready(() => {
    umeMenuInit();
    scrollDownOnClick();
    umeMoreFrontend();
    umeSlidersInit();
    umeReadyAccordions();
    smoothscroll.polyfill();
    retina();
    initSliders();
    initUpcomingEventsSliders();
    studiesSelect();
    checkIfAnchorIsInViewport();
    setScrollPadding();
    consentmanager();
    consentManagerHandleBackground();
   // linktree();
});
let currentWidth = window.innerWidth;
window.addEventListener('resize', () => {
    if(currentWidth === window.innerWidth) return;
    umeMenuInit();
    setScrollPadding();
    currentWidth = window.innerWidth;

});
window.addEventListener('orientationchange', () => {
    umeMenuInit();
    setScrollPadding();
});